export const footerClasses = 'relative overflow-hidden flex justify-center';
export const footerCommonGridMenuClasses = 'grid w-full';

const footerCommonTheme = {
  footerClasses,
  footerCommonGridMenuClasses,
};

export default footerCommonTheme;
